export default "pdvend";



// WEBPACK FOOTER //
// ./src/assets/enum/whitelabel/pdvend/index.js